/* assets/section-custom-clothing.js */
(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function init(sectionEl) {
    const prev = sectionEl.querySelector("[data-cc-gallery-prev]");
    const next = sectionEl.querySelector("[data-cc-gallery-next]");
    const viewport = sectionEl.querySelector("[data-cc-gallery-viewport]");
    if (!prev || !next || !viewport) return;

    let index = 0;
    let lastMode = isMobile() ? "mobile" : "desktop";

    function getTrack(mode) {
      return sectionEl.querySelector(
        `[data-cc-gallery-track][data-track="${mode}"]`
      );
    }

    function getCount(mode, track) {
      if (!track) return 0;
      return mode === "desktop"
        ? track.querySelectorAll("[data-cc-gallery-slide]").length
        : track.querySelectorAll("[data-cc-gallery-item]").length;
    }

    function getStep(mode, track) {
      if (!track) return 0;
      if (mode === "desktop") {
        return viewport.getBoundingClientRect().width;
      }
      const item = track.querySelector("[data-cc-gallery-item]");
      if (!item) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.gap || styles.columnGap || "24") || 24;
      return item.getBoundingClientRect().width + gap;
    }

    function setDisabled(count) {
      const atStart = index <= 0;
      const atEnd = index >= count - 1;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.setAttribute("aria-disabled", atStart ? "true" : "false");
      next.setAttribute("aria-disabled", atEnd ? "true" : "false");
    }

    function update() {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      if (!track) return;
      if (mode !== lastMode) {
        index = 0;
        const other = getTrack(mode === "mobile" ? "desktop" : "mobile");
        if (other) other.style.transform = "translate3d(0,0,0)";
        lastMode = mode;
      }
      const count = getCount(mode, track);
      var nav = sectionEl.querySelector(".cc-galleryF__nav");
      if (nav) nav.style.display = count <= 1 ? "none" : "flex";
      if (count <= 0) return;
      if (index > count - 1) index = count - 1;
      if (index < 0) index = 0;
      const step = getStep(mode, track);
      track.style.transform = `translate3d(-${index * step}px,0,0)`;
      setDisabled(count);
    }

    prev.addEventListener("click", function () {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      const count = getCount(mode, track);
      if (count <= 0) return;
      if (index <= 0) return;
      index -= 1;
      update();
    });

    next.addEventListener("click", function () {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      const count = getCount(mode, track);
      if (count <= 0) return;
      if (index >= count - 1) return;
      index += 1;
      update();
    });

    window.addEventListener("resize", update);
    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-cc-gallery]").forEach(init);
  });

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target) return;
    e.target.querySelectorAll("[data-cc-gallery]").forEach(init);
  });
})();
